export const withCWModalSupport = (link) => {
  const parts = link.nextLink?.url?.split('?');
  if (!parts || parts.length < 2) {
    return link;
  }

  const query = new URLSearchParams(parts[1]);
  if (!query.has('charity_donation')) {
    return link;
  }

  return { ...link, nextLink: { ...link.nextLink, cwModal: true } };
};
